<template>
  <div class="top-banner-title-comp">
    <div class="return" @click="goToPreviousView">
      <i
          class="mdi mdi-arrow-left"
      ></i>
    </div>
    <div class="title">
      {{title}}
    </div>
  </div>
</template>

<script>
export default {
  name: "top-banner",

  props : {
    title : {
      type : String,
      required : true
    }
  },


  data(){
    return{
      prevRoute : null,
    }
  },

  mounted(){
    console.log("lastRoute",this.$store.state.lastRoute)
  },

  methods : {
    goToPreviousView(){
      this.$router.push(this.$store.state.lastRoute) ;
    }
  }
}
</script>

<style scoped>

</style>